import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
import { nextTick } from 'vue'
const baseUri = "WebApi.asmx/api/suchfeldService";
const store = {};
const mutations = {
    SET_SUCHFELD_RSS_LIST(state, posts) {
        state.suchfeldRssList = posts.suchfeldList;
        state.suchfeldRssListChanged = false;
        state.suchfeldRssListIsLoading = false;
    },
    SET_RSS_SUCHFELD_LIST(state, posts) {
        state.rssSuchfeldList = posts.rssFeedList;
        state.rssSuchfeldListChanged = false;
        state.rssSuchfeldListIsLoading = false;
    },
    SAVE_SUCHFELD_RSS_LIST(state, posts) {
        if (posts.success == false) {
            alert(posts.errorMessage);
        }
        else {
            state.suchfeldRssListChanged = false;
            state.suchfeldDetail.SufImageUri = null;
        }
    },
    SAVE_RSS_SUCHFELD_LIST(state, posts) {
        if (posts.success == false) {
            alert(posts.errorMessage);
        }
        else {
            state.rssSuchfeldListChanged = false;
        }
    },
    GET_DETAIL(state, posts) {
        if (posts.success == true) {
            state.sufImage = posts.data.SufImageUri;
            posts.data.SufImageUri = null;
            state.suchfeldDetail = posts.data;
            nextTick(function () {
                state.suchfeldDetailChanged = false;
                state.suchfeldDetailIsLoading = false;
            });
        }
        else {
            alert(posts.errorMessage);
        }
    },
    GET_DETAIL_VX(state, posts) {
        if (posts.success == true) {
            state.sufImage = posts.data.SufImageUri;
            posts.data.SufImageUri = null;
            state.suchfeldDetailVx = posts.data;
            nextTick(function () {
                state.suchfeldDetailChanged = false;
                state.suchfeldDetailIsLoading = false;
            });
        }
        else {
            alert(posts.errorMessage);
        }
    }, GET_SUCHFELD_INFO(state, posts) {
        if (posts.success == true) {
            state.suchfeldInfo = posts.data;
        }
        else {
            alert(posts.errorMessage);
        }
        this.suchfeldNameIsLoading = false;
    },
    SAVE_DETAIL(state, posts) {
        if (posts.success == true) {
            state.suchfeldDetailChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
    SET_KEYWORDS(state, posts) {
        state.suchfeldDetail.SufKeyWords = posts.result;
    },
    DELETE_SUCHFELD(state) {
        state.suchfeldDeleted = true;
    }
};
const state = {
    suchfeldRssListIsLoading: false,
    rssSuchfeldListIsLoading: false,
    suchfeldDeleted: false,
    suchfeldRssList: [],
    rssSuchfeldList: [],
    sufImage: null,
    suchfeldRssListChanged: false,
    rssSuchfeldListChanged: false,
    suchfeldDetail: {},
    suchfeldDetailVx: {},
    suchfeldDetailChanged: false,
    suchfeldDetailIsLoading: false,
    suchfeldName: "",
    suchfeldNameIsLoading: false,
};
const getters = {};
const actions = {
    getAllSuchfeldInfosForRssFeed({ commit }, data) {
        state.suchfeldRssListIsLoading = true;
        var formData = new FormData();
        formData.append("rssId", data.rssId);
        axios
            .post(baseUri + '/GetAllSuchfeldInfosForRssFeed', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_SUCHFELD_RSS_LIST', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getAllRssFeedInfosForSuchfeld({ commit }, data) {
        state.suchfeldRssListIsLoading = true;
        var formData = new FormData();
        formData.append("litId", data.litId);
        axios
            .post(baseUri + '/GetAllRssFeedInfosForSuchfeld', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_RSS_SUCHFELD_LIST', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    saveSuchfeldRssList({ commit }, data) {
        var formData = new FormData();
        formData.append("rssId", data.rssId);
        formData.append("data", JSON.stringify(state.suchfeldRssList));
        axios
            .post(baseUri + '/SaveAllSuchfeldInfosForRssFeed', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SAVE_SUCHFELD_RSS_LIST', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    saveRssSuchfeldList({ commit }, data) {
        var formData = new FormData();
        formData.append("litId", data.litId);
        formData.append("data", JSON.stringify(state.rssSuchfeldList));
        axios
            .post(baseUri + '/SaveAllRssFeedInfosForSuchfeld', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SAVE_RSS_SUCHFELD_LIST', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    deleteSuchfeld({ commit }, data) {
        var formData = new FormData();
        formData.append("litId", data.litId);
        axios
            .post(baseUri + '/DeleteSuchfeld', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('DELETE_SUCHFELD');
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    saveSuchfeldDetail({ commit }) {
        var formData = new FormData();
        formData.append("data", JSON.stringify(state.suchfeldDetail));
        axios
            .post(baseUri + '/SaveDetail', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SAVE_DETAIL', res.data);
                } else {
                    alert("An error occured while updating your record: " + res.data.errorMessage);
                }
            });
    },
    extractSuchfeldKeywords({ commit }) {
        var formData = new FormData();
        formData.append("data", JSON.stringify(state.suchfeldDetail));
        axios
            .post(baseUri + '/ExtractSuchfeldKeywords', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_KEYWORDS', res.data);
                } else {
                    alert("An error occured while updating rss feed: " + res.data.errorMessage);
                }
            });
    },
    getSuchfeldDetail({ commit }, data) {
        state.suchfeldDetailIsLoading = true;
        var formData = new FormData();
        formData.append("litId", data.litId);
        axios
            .post(baseUri + '/GetDetail', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_DETAIL', res.data);
                }
                else {
                    this.suchfeldDetailIsLoading = false;
                    alert(res.data.errorMessage);
                }
            });
    },
    getSuchfeldInfo({ commit }, data) {
        var formData = new FormData();
        formData.append("LitId", data.sufId);
        axios
            .post(baseUri + '/GetSuchfeldInfo', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_SUCHFELD_INFO', res.data);
                }
                else {
                    this.suchfeldNameIsLoading = false;
                    alert(res.data.errorMessage);
                }
            });
    },
    getSuchfeldDetailVx({ commit }, data) {
        state.suchfeldDetailIsLoading = true;
        var formData = new FormData();
        formData.append("litId", data.litId);
        axios
            .post(baseUri + '/GetDetailVx', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_DETAIL_VX', res.data);
                }
                else {
                    this.suchfeldDetailIsLoading = false;
                    alert(res.data.errorMessage);
                }
            });
    },
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}